import { ReactNode } from 'react'
import { cn } from '@/utils/cn'

export interface MetricItem {
  value: ReactNode
  label: ReactNode
  description?: ReactNode
}

interface MetricRowProps {
  items: MetricItem[]
  className?: string
}

export function MetricRow({ items, className }: MetricRowProps) {
  return (
    <div className={cn('eh-metric-row eh-stagger', className)} role="list">
      {items.map((item, index) => (
        <div
          key={typeof item.label === 'string' ? item.label : index}
          className="eh-metric-row__item eh-reveal"
          role="listitem"
        >
          <div className="eh-display text-[clamp(1.75rem,3vw,2.5rem)] text-eh-forest-ink">
            {item.value}
          </div>
          <div className="mt-2 text-sm font-semibold text-eh-forest-ink">{item.label}</div>
          {item.description ? (
            <div className="eh-caption mt-2">{item.description}</div>
          ) : null}
        </div>
      ))}
    </div>
  )
}

export default MetricRow
